import { Control, Controller } from 'react-hook-form';
import { ContactSyncModel } from '../../../../../types';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface StepThreeProps {
  control: Control<Partial<ContactSyncModel>>;
}

export default function StepThree({ control }: StepThreeProps) {
  return (
    <Box
      sx={{
        viewTransitionName: 'steps',
      }}
    >
      <Stack
        flexDirection={'row'}
        gap={10}
        sx={{ pt: 2 }}
        justifyContent="center"
      >
        <Stack gap={1}>
          <Typography sx={{ pl: 2 }}>Source</Typography>
          <Controller
            name="trackSrcCreate"
            control={control}
            render={({ field: props }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...props}
                    checked={props.value}
                    onChange={(e) => props.onChange(e.target.checked)}
                  />
                }
                label="Creates"
              />
            )}
          />
          <Controller
            name="trackSrcUpdate"
            control={control}
            render={({ field: props }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...props}
                    checked={props.value}
                    onChange={(e) => props.onChange(e.target.checked)}
                  />
                }
                label="Updates"
              />
            )}
          />
          <Controller
            name="trackSrcDelete"
            control={control}
            render={({ field: props }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...props}
                    checked={props.value}
                    onChange={(e) => props.onChange(e.target.checked)}
                  />
                }
                label="Deletes"
              />
            )}
          />
        </Stack>
        <Stack alignContent={'center'} justifyContent={'center'} gap={1}>
          <Typography sx={{ pl: 2 }}>Targets</Typography>
          <Controller
            name="trackDestCreate"
            control={control}
            render={({ field: props }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...props}
                    checked={props.value}
                    onChange={(e) => props.onChange(e.target.checked)}
                  />
                }
                label="Creates"
              />
            )}
          />
          <Controller
            name="trackDestUpdate"
            control={control}
            render={({ field: props }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...props}
                    checked={props.value}
                    onChange={(e) => props.onChange(e.target.checked)}
                  />
                }
                label="Updates"
              />
            )}
          />
          <Controller
            name="trackDestDelete"
            control={control}
            render={({ field: props }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    {...props}
                    checked={props.value}
                    onChange={(e) => props.onChange(e.target.checked)}
                  />
                }
                label="Deletes"
              />
            )}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
